<template>
  <div class="list-column">
    <div style="padding-top: 10px"></div>
    <div class="list-reset">
      <draggable
        v-model="list"
        @start="drag=true"
        @end="drag=false"
        handle=".handle"
      >
        <ColumnItem
          v-for="(item, $itemIndex) of list"
          :key="$itemIndex"
          :item="item"
        />
      </draggable>

      <input
        type="text"
        class="new-item block p-2 w-full bg-transparent"
        placeholder="+ Enter new item"
        @keyup.enter="createItem($event, list)"
      >
    </div>
  </div>
</template>

<script>
import ColumnItem from "./ColumnItem.vue";
import draggable from "vuedraggable";

export default {
  components: {
    ColumnItem,
    draggable,
  },
  computed: {
    list: {
      get() {
        return this.$store.state.list;
      },
      set(value) {
        this.$store.commit("UPDATE_LIST", value);
      },
    },
  },
  methods: {
    createItem(e, list) {
      var name = e.target.value.trim();

      if (name === "") {
        e.target.value = "";
        return;
      }

      this.$store.commit("CREATE_ITEM", {
        list,
        name: name,
      });

      e.target.value = "";
    },
  },
};
</script>

<style>
.list-column {
  @apply bg-grey-light p-2 text-left shadow rounded;
  width: 100%;
  background-image: linear-gradient(
    to right,
    #f67280 2%,
    #c06c84 51%,
    #6c5b78 100%
  );
  border-radius: 10px;
}

.delete {
  margin-left: auto;
  padding-right: 2px;
  color: darkgray;
  cursor: pointer;
}

.delete:hover {
  color: darkgray;
  color: grey;
}

.list-reset {
  position: relative;
}

.new-item {
  margin-bottom: 10px;
  color: white;
  font-weight: 600;
}

.new-item::placeholder {
  color: rgb(255, 255, 255);
  opacity: 1;
  font-weight: 600;
}
</style>